// import React, { createContext, useEffect, useReducer } from "react";
// import axios from "axios";
// import { AppLoading } from "app/components"; // Replace with your actual loading UI

// // ─── Initial State ─────────────────────────────────────────────
// const initialState = {
//   isAuthenticated: false,
//   isInitialised: false,
//   user: null,
// };

// // ─── Token Check ───────────────────────────────────────────────
// // No JWT decoding since backend doesn't send JWT
// const isValidToken = (accessToken) => !!accessToken;

// // ─── Set Session ───────────────────────────────────────────────
// export const setSession = (accessToken) => {
//   if (accessToken) {
//     localStorage.setItem("accessToken", accessToken);
//     axios.defaults.headers.common.Authorization = `Bearer ${accessToken}`;
//   } else {
//     localStorage.removeItem("accessToken");
//     delete axios.defaults.headers.common.Authorization;
//   }
// };

// // ─── Reducer ───────────────────────────────────────────────────
// const reducer = (state, action) => {
//   switch (action.type) {
//     case "INIT": {
//       const { isAuthenticated, user } = action.payload;
//       return {
//         ...state,
//         isAuthenticated,
//         isInitialised: true,
//         user,
//       };
//     }
//     case "LOGIN": {
//       const { user } = action.payload;
//     console.log("Logged-in user:", user);
//       return {
//         ...state,
//         isAuthenticated: true,
//         user,
//       };
//     }
//     case "LOGOUT": {
//       return {
//         ...state,
//         isAuthenticated: false,
//         user: null,
//       };
//     }
//     case "REGISTER": {
//       const { user } = action.payload;
//       return {
//         ...state,
//         isAuthenticated: true,
//         user,
//       };
//     }
//     case "UPDATE_USER": {
//       const { user } = action.payload;
//       return {
//         ...state,
//         user,
//       };
//     }
//     default: {
//       return state;
//     }
//   }
// };

// // ─── Context Creation ───────────────────────────────────────────
// const AuthContext = createContext({
//   ...initialState,
//   method: "custom",
//   login: () => Promise.resolve(),
//   logout: () => {},
//   register: () => Promise.resolve(),
//   updateUser: () => {},
// });

// // ─── Provider ───────────────────────────────────────────────────
// export const AuthProvider = ({ children }) => {
//   const [state, dispatch] = useReducer(reducer, initialState);

//   // ─── Login ─────────────────────────────────────────────
// const login = async ({
//   email,
//   password,
//   loginMethod ,        // "1" = default to normal login
//   googleToken,
//   deviceIP ,
//   deviceName
// }) => {
//   try {
//     const response = await axios.post(
//       "https://dvmtcreaapi.bexatm.com/api/Login/Login",
//       //  "https://uatapi.creanetwork.in/api/Login/Login",
//       {
//         LoginID: email,
//         Password: password,
//         LoginMethod: loginMethod,
//         GoogleToken: googleToken,
//         DeviceIP: deviceIP,
//         DeviceName: deviceName,
//       },
//       {
//         headers: {
//           Authorization: process.env.REACT_APP_API_TOKEN,
//         },
//       }
//     );

//     const { Status, Message, Data } = response.data;

//     if (Status !== "Y") {
//       throw new Error(Message || "Invalid credentials");
//     }

//     sessionStorage.setItem("authToken", Data.Token);
//     sessionStorage.setItem("LoginID", Data.UserID);
//     localStorage.setItem("user", JSON.stringify(Data));

//     dispatch({
//       type: "LOGIN",
//       payload: { user: Data },
//     });

//     return Data;
//   } catch (error) {
//     if (error.response) {
//       const { Message } = error.response.data || {};
//       throw new Error(Message || "Login failed. Please check your credentials.");
//     } else if (error.request) {
//       throw new Error("No response from server. Please try again later.");
//     } else {
//       throw new Error(error.message || "Unexpected error occurred.");
//     }
//   }
// };


//   // ─── Register (not used but included) ─────────────────────────
//   const register = async (email, username, password) => {
//     const response = await axios.post("/api/auth/register", {
//       email,
//       username,
//       password,
//     });

//     const { accessToken, user } = response.data;

//     setSession(accessToken);

//     dispatch({
//       type: "REGISTER",
//       payload: { user },
//     });
//   };

//   // ─── Logout ─────────────────────────────────────────────
//   const logout = () => {
//     setSession(null);
//     localStorage.removeItem("user");
//     dispatch({ type: "LOGOUT" });
//   };

//   // ─── Update User ───────────────────────────────────────
//   const updateUser = (user) => {
//     dispatch({ type: "UPDATE_USER", payload: { user } });
//     localStorage.setItem("user", JSON.stringify(user));
//   };

//   // ─── Auto Init on App Load ─────────────────────────────
//   useEffect(() => {
//     const initAuth = async () => {
//       try {
//         const accessToken = localStorage.getItem("accessToken");
//         const user = JSON.parse(localStorage.getItem("user"));

//         if (accessToken && isValidToken(accessToken) && user) {
//           setSession(accessToken);
//           dispatch({
//             type: "INIT",
//             payload: {
//               isAuthenticated: true,
//               user,
//             },
//           });
//         } else {
//           dispatch({
//             type: "INIT",
//             payload: {
//               isAuthenticated: false,
//               user: null,
//             },
//           });
//         }
//       } catch (err) {
//         console.error("Auth init error:", err);
//         dispatch({
//           type: "INIT",
//           payload: {
//             isAuthenticated: false,
//             user: null,
//           },
//         });
//       }
//     };

//     initAuth();
//   }, []);

//   // ─── Loading Placeholder ───────────────────────────────
//   if (!state.isInitialised) {
//     return <AppLoading />; // your custom loading spinner
//   }

//   // ─── Final Return ───────────────────────────────────────
//   return (
//     <AuthContext.Provider
//       value={{
//         ...state,
//         method: "custom",
//         login,
//         logout,
//         register,
//         updateUser,
//       }}
//     >
//       {children}
//     </AuthContext.Provider>
//   );
// };

// export default AuthContext;











// const login = async (email, password) => {
//   try {
//     const response = await axios.post(
//       "https://dvmtcreaapi.bexatm.com/api/Login/Login",
//       {
//         LoginID: email,
//         Password: password,
//         LoginMethod: login,
//       },
//       {
//         headers: {
//           Authorization: process.env.REACT_APP_API_TOKEN,
//         },
//       }
//     );

//     const { Status, Message, Data } = response.data;

//     if (Status !== "Y") {
//       throw new Error(Message || "Invalid credentials");
//     }

//     sessionStorage.setItem("authToken", Data.Token);
//     localStorage.setItem("user", JSON.stringify(Data));

//     dispatch({
//       type: "LOGIN",
//       payload: { user: Data },
//     });

//     return Data;
//   } catch (error) {
//     if (error.response) {
//       const { Message } = error.response.data || {};
//       throw new Error(Message || "Login failed. Please check your credentials.");
//     } else if (error.request) {
//       throw new Error("No response from server. Please try again later.");
//     } else {
//       throw new Error(error.message || "Unexpected error occurred.");
//     }
//   }
// };







  // const login = async (email, password) => {
//   try {
//     const response = await axios.post(
//       "https://dvmtcreaapi.bexatm.com/api/Login/Login",
//       {
//         LoginID: email,
//         Password: password,
//         LoginMethod: "1",
//       },
//       {
//         headers: {
//           Authorization: process.env.REACT_APP_API_TOKEN,
//         },
//       }
//     );

//     const { Status, Message, Data } = response.data;

//     if (Status !== "Y") {
//       throw new Error(Message || "Invalid credentials");
//     }

//     sessionStorage.setItem("authToken", Data.Token);
//     localStorage.setItem("user", JSON.stringify(Data));

//     dispatch({
//       type: "LOGIN",
//       payload: { user: Data },
//     });

//     return response.data;
//   } catch (error) {
//     // 🔍 Handle both network and custom API errors
//     if (error.response) {
//       // API returned a non-200 response
//       const { Message } = error.response.data || {};
//       throw new Error(Message || "Login failed. Please check your credentials.");
//     } else if (error.request) {
//       // No response from server
//       throw new Error("No response from server. Please try again later.");
//     } else {
//       // Something else (e.g., coding error)
//       throw new Error(error.message || "Unexpected error occurred.");
//     }
//   }
// };


//   const login = async (email, password) => {
//   const response = await axios.post(
//     "https://dvmtcreaapi.bexatm.com/api/Login/Login",
//     {
//       LoginID: email,
//       Password: password,
//       LoginMethod: "1",
//     },
//     {
//       headers: {
//         Authorization: process.env.REACT_APP_API_TOKEN,
//       },
//     }
//   );

//   const { Status, Message, Data } = response.data;

//   if (Status !== "Y") {
//     throw new Error(Message || "Invalid credentials");
//   }

//   // ✅ Store actual token in sessionStorage
//   sessionStorage.setItem("authToken", Data.Token);

//   // ✅ Store user data
//   localStorage.setItem("user", JSON.stringify(Data));

//   dispatch({
//     type: "LOGIN",
//     payload: { user: Data },
//   });

//   return response.data;
// };

//   const login = async (email, password) => {
//   const response = await axios.post(
//     "https://dvmtcreaapi.bexatm.com/api/Login/Login",
//     {
//       LoginID: email,
//       Password: password,
//       LoginMethod: "1",
//     },
//     {
//       headers: {
//         Authorization: process.env.REACT_APP_API_TOKEN,
//       },
//     }
//   );

//   const { Status, Message, Data } = response.data;

//   if (Status !== "Y") {
//     throw new Error(Message || "Invalid credentials");
//   }

//   setSession("dummy-token");
//  sessionStorage.setItem("authToken", Data.Token);
//   localStorage.setItem("user", JSON.stringify(Data));

//   dispatch({
//     type: "LOGIN",
//     payload: { user: Data },
//   });

//   return response.data;
// };










import React, { createContext, useEffect, useReducer } from "react";
import jwtDecode from "jwt-decode";
import axios from "axios";
import { AppLoading } from "app/components";

const initialState = {
  isAuthenticated: false,
  isInitialised: false,
  user: null,
};

const isValidToken = (accessToken) => {
  if (!accessToken) {
    return false;
  }
  const decodedToken = jwtDecode(accessToken);
  const currentTime = Date.now() / 1000;
  return decodedToken.exp > currentTime;
};

const setSession = (accessToken) => {
  if (accessToken) {
    localStorage.setItem("accessToken", accessToken);
    axios.defaults.headers.common.Authorization = `Bearer ${accessToken}`;
  } else {
    localStorage.removeItem("accessToken");
    delete axios.defaults.headers.common.Authorization;
  }
};

const reducer = (state, action) => {
  switch (action.type) {
    case "INIT": {
      const { isAuthenticated, user } = action.payload;
     
      return {
        ...state,
        isAuthenticated,
        isInitialised: true,
        user,
      };
    }
    case "LOGIN": {
      const { user } = action.payload;

      return {
        ...state,
        isAuthenticated: true,
        user,
      };
    }
    case " LOGOUT": {
      const { user } = action.payload;

      return {
        ...state,
        isAuthenticated: false,
        user
      };
    }
    case "REGISTER": {
      const { user } = action.payload;

      return {
        ...state,
        isAuthenticated: true,
        user,
      };
    }
    // case "UPDATE_USER": {
    //   const { user } = action.payload;
    //   state.user = user;
    // }
    case "UPDATE_USER":
  return {
    ...state,
    user: {
      ...state.user,
      ...action.payload.user,
    },
  };
    default: {
      return { ...state };
    }
  }
};

const AuthContext = createContext({
  ...initialState,
  method: "JWT",
  login: () => Promise.resolve(),
  logout: () => {},
  register: () => Promise.resolve(),
  updateUser: () => {},
    userRole: () => Promise.resolve(),
});

export const AuthProvider = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState);
  const login = async ({
  email,
  password,
  loginMethod ,        // "1" = default to normal login
  googleToken,
  deviceIP ,
  deviceName
}) => {
  try {
    const response = await axios.post(
      // "https://dvmtcreaapi.bexatm.com/api/Login/Login",
        // "https://uatapi.creanetwork.in/api/Login/Login",
        "https://api.creanetwork.in/api/Login/Login",
      {
        LoginID: email,
        Password: password,
        LoginMethod: loginMethod,
        GoogleToken: googleToken,
        DeviceIP: deviceIP,
        DeviceName: deviceName,
      },
      {
        headers: {
          Authorization: process.env.REACT_APP_API_TOKEN,
        },
      }
    );

    const { Status, Message, Data,IsUserExist } = response.data;

    if (Status !== "Y") {
      throw new Error(Message || "Invalid credentials");
    }
     

    sessionStorage.setItem("authToken", Data.Token);
    sessionStorage.setItem("LoginID", Data.UserID);
    localStorage.setItem("user", JSON.stringify(Data));

    dispatch({
      type: "LOGIN",
      payload: { user: Data },
    });

      // ✅ Return complete login data
    return { ...Data, IsUserExist };
  } catch (error) {
    if (error.response) {
      const { Message } = error.response.data || {};
      throw new Error(Message || "Login failed. Please check your credentials.");
    } else if (error.request) {
      throw new Error("No response from server. Please try again later.");
    } else {
      throw new Error(error.message || "Unexpected error occurred.");
    }
  }
};
  // const login = async (email, password) => {
    
  //   const response = await axios.post("/api/Login/Login", {
  //     email,
  //     password,
  //   });

  //   console.log('login',response);
    
  //   const { accessToken, user } = response.data;

  //   setSession(accessToken);

  //   dispatch({
  //     type: "LOGIN",
  //     payload: {
  //       user,
  //     },
  //   });
  // };
// const login = async (email, password) => {
//     const response = await axios.post(
//       "https://dvmtcreaapi.bexatm.com/api/Login/Login",
//       {
//         LoginID: email,
//         Password: password,
//         LoginMethod: "1",
//       },
//       {
//         headers: {
//           Authorization: process.env.REACT_APP_API_TOKEN, // Add this if your API needs a token
//         },
//       }
//     );

//     console.log("login response", response);

//     const { Status, Message,Data } = response.data;

//     if (Status !== "Y") {
//       throw new Error(Message || "Invalid credentials");
//     }

//     // Set session if required — dummy token or user info
//     setSession("dummy-token"); // or whatever your logic is

//     dispatch({
//       type: "LOGIN",
//       payload: {
//         user: UserDetails,
//       },
//     });

//     return response.data;
//   };
  const register = async (email, username, password) => {
    const response = await axios.post("/api/auth/login", {
      email,
      username,
      password,
    });

    const { accessToken, user } = response.data;

    setSession(accessToken);

    dispatch({
      type: "REGISTER",
      payload: {
        user,
      },
    });
  };


  const userRole = async (UserID, RoleID,deviceIP ,
  deviceName) => {
      try {
    const response = await axios.put("https://api.creanetwork.in/api/UserProfile/UpdateRoles",
{UserID, RoleID, deviceIP ,
  deviceName
    } ,{
        headers: {
          Authorization: process.env.REACT_APP_API_TOKEN,
        },
      });

    const { Status, Message, Data,Token } = response.data;
console.log(Token,"Data.Token");
    if (Status !== "Y") {
      throw new Error(Message || "Invalid credentials");
    }
     

    sessionStorage.setItem("authToken",Token);
    sessionStorage.setItem("LoginID", Data.UserID);
    localStorage.setItem("user", JSON.stringify(Data));


    dispatch({
      type: "LOGIN",
      payload: { user: Data },
    });

      // ✅ Return complete login data
    return { ...Data, };
  } catch (error) {
    if (error.response) {
      const { Message } = error.response.data || {};
      throw new Error(Message || "Login failed. Please check your credentials.");
    } else if (error.request) {
      throw new Error("No response from server. Please try again later.");
    } else {
      throw new Error(error.message || "Unexpected error occurred.");
    }
  }

  };
  const logout = () => {
    setSession(null);
    dispatch({ type: "LOGOUT" });
  };

  const updateUser = (user) => {
    dispatch({ type: "UPDATE_USER" ,payload: {
      user,
    }, });
  };

  useEffect(() => {
    (async () => {
      try {
        const accessToken = window.localStorage.getItem("accessToken");

        if (accessToken && isValidToken(accessToken)) {
          
          setSession(accessToken);
          const response = await axios.get("link");
          const { user } = response.data;

          dispatch({

            type: "INIT",
            payload: {
              isAuthenticated: true,
              user,
            },
          });
        } else {
          
          dispatch({
            type: "INIT",
            payload: {
              isAuthenticated: false,
              user: null,
            },
          });
        }
      } catch (err) {
    
        console.log(err);
        dispatch({
          type: "INIT",
          payload: {
            isAuthenticated: false,
            user: null,
          },
        });
      }
    })();
  }, []);
  if (!state.isInitialised) {
    // console.log("🚀 ~ file: JWTAuthContext.js:171 ~ AuthProvider ~ !state.isInitialised:", state.isInitialised)
    return <AppLoading />;
  }

  return (
    <AuthContext.Provider
      value={{
        ...state,
        method: "JWT",
        login,
        logout,
        register,
        updateUser,
        userRole
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export default AuthContext;
